import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

/*
  Old project articles (Membership, Gold Medals, Library, etc.) moved to
  src/data/priorityProjects.js — shown in modals on the Donation page (/donation).
*/

const VISION_OBJECTIVES = [
  {
    title: '1. Strengthen Alumni–Institute Connections',
    body: 'Establish a structured community for LITU alumni in North America to connect with each other and with the institute, fostering consistent engagement and shared identity.',
  },
  {
    title: '2. Support Education through Scholarships and Awards',
    body: 'Provide funding, scholarships, or awards to students or faculty at LITU, recognizing academic excellence and leadership.',
  },
  {
    title: '3. Mentorship, Career Support & Professional Development',
    body: 'Mentor current students and recent graduates, offer career guidance, internships, and industry insights as well as support job placement and professional transition help especially for grad students and early-career members.',
  },
  {
    title: '4. Facilitate Institutional Advancement & Resource Mobilization',
    body: 'Mobilize alumni expertise, volunteering, and resources (financial or in-kind) to support academic growth. Raise funds to support select academic and infrastructure projects.',
  },
  {
    title: '5. Elevate LITU’s Brand, Reputation & Collaboration',
    body: 'Serve as ambassadors in North America to promote LITU’s academic reputation, research collaborations, and partnerships—for LITU’s brand-building in the educational and corporate ecosystem in North America.',
  },
]

export default function Projects() {
  return (
    <>
      <div className="main-wrapper page page-projects">
        <Navbar />
        <div className="content-wrapper" data-aos="fade-up">
          <div className="about-us" data-aos="fade-up">
            <div className="about-us-title text-center">
              <div className="container">
                <h1 className="heading-bold text-uppercase">VISION & MISSION</h1>
                <p className="page-hero-subtitle">
                  Our alma mater gave us the foundation for everything we have built. Now it is our turn.
                </p>
              </div>
            </div>
          </div>

          <div className="blog-content">
            <div className="container page-projects-container">
              <div className="row">
                <div className="col-xs-12 page-projects-main">
                  <div className="litaana-vision-mission" data-aos="fade-up">
                    <div className="litaana-vision-mission__intro">
                      <p>
                        <strong>Laxminarayan Innovation Technological University (LITU)</strong> is a premier chemical engineering and technology institution located in Nagpur, in the heart of central India. With a legacy of excellence in education and research, LITU has produced generations of distinguished chemical engineers and technologists contributing across industries and academia worldwide.
                      </p>
                      <p>
                        The <strong>LITU Alumni Association</strong> is a vibrant network of graduates who remain actively engaged with the institute and with one another. Notably, the association includes a strong and growing chapter in <strong>North America</strong>, with <strong>over 150 alumni</strong> currently based across the United States and Canada. These alumni represent leadership across sectors—from chemical and pharmaceutical industries to research, entrepreneurship, and public service—serving as a bridge between LITU and the global scientific community.
                      </p>
                    </div>

                    <h2 className="litaana-vision-mission__heading">
                      Proposed Objectives for the LITU North America Alumni Association NonProfit
                    </h2>

                    <ol className="litaana-vision-mission__objectives">
                      {VISION_OBJECTIVES.map((objective) => (
                        <li key={objective.title}>
                          <h3>{objective.title}</h3>
                          <p>{objective.body}</p>
                        </li>
                      ))}
                    </ol>
                  </div>

                  {/* Old intro + 8 project article-items + How to Give + Conclusion — moved to Donation page modals (src/data/priorityProjects.js)
                  <div className="articles">...</div>
                  */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}
